export type AuthReturnState = {
  from?: string;
};

export const buildAuthReturnPath = (pathname: string, search: string): string =>
  `${pathname}${search}`;

export const resolveAuthReturnPath = (state: unknown, fallback = '/balance'): string => {
  const from = (state as AuthReturnState | null)?.from;

  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('/auth')) {
    return fallback;
  }

  return from;
};
